<div class="blue-background">
  <div style="margin-left: auto; margin-right: auto">
    <div class="ylapalkki">
      <button class="sulje" mat-button (click)="peruuta()" type="button">
        <i style="font-size: 60px; width: 60px; height: 60px; line-height: 60px; display: inline-block" class="icon ion-md-arrow-back"></i>
      </button>

      <h2 style="margin: 0; width: calc(100% - 18vw); text-align: center">
        {{ 'maksut.muokkaa.otsikko-lisaa' | translate | async }}
      </h2>
    </div>
  </div>
</div>

<div class="kuitti-container">
  <form novalidate autocomplete="kirjanpitoaineistoarkki" style="width: 100%">
    <!-- <div *ngIf="naytaYhdistaKuitit" style="margin-bottom: 10px;">
    <mat-checkbox [disabled]="yhdistaminenDisabled" (change)="yhdistaKuitit($event)" style="font-size: 14px;">{{ 'kuitit.muokkaa.yhdista' | translate | async }}</mat-checkbox>
  </div> -->

    <div>
      @for (rivi of lomake.tositeArray; track rivi; let i = $index) {
        <div class="tosite-container">
          <div class="tosite-tiedot">
            @if (virheviestiPysyva()) {
              <div class="error-text" style="padding-bottom: 2em">
                {{ virheviestiPysyva() }}
              </div>
            }
            <!-- <h1 *ngIf="naytaYhdistaKuitit" style="font-size: 28px; line-height: 34px; text-align: left;" class="light-blue-text">{{ 'kuitit.muokkaa.tosite' | translate | async }} {{i+1}}</h1> -->
            <!-- <div *ngIf="showMaksutapa" style="padding-bottom: 5px;">
          <div class="mat-form-field" style="font-size: 10.5px;">{{ 'kuitit.muokkaa.maksettu' | translate | async }} *</div>
          <app-kuitit-maksutapa formControlName="maksutapa" [filterNonActive]="true" [error]="group.get('maksutapa')?.errors?.length"></app-kuitit-maksutapa>
          <mat-error *ngIf="group.get('maksutapa'); let n">
            <ng-container *ngIf="(n?.dirty || n?.touched)">
              <ng-container *ngIf="(saajaVar?.ngControl?.dirty || saajaVar?.ngControl?.touched) && saajaVar.ngControl?.errors?.required">{{ 'kuitit.muokkaa.validation.maksutapa.required' | translate | async }}</ng-container>
            </ng-container>
          </mat-error>
        </div> -->
            <mat-form-field>
              @if (valittuToimittaja()) {
                <div class="toimittaja-numero">
                  {{ toimittaja().numero }}
                </div>
              }
              <mat-label>{{ 'maksut.muokkaa.toimittaja' | translate | async }}</mat-label>
              <input #toimittajaVar="matInput" type="text" autocomplete="kirjnpitomekiarki" [matAutocomplete]="toimittajaAuto" [formField]="rivi.toimittaja" (keydown.backspace)="tarkistaToimittajaPoisto()" (paste)="onToimittajaPaste($event)" matInput data-lpignore="true" />
              @if (valittuToimittaja()) {
                <i style="cursor: pointer; font-size: 30px" matSuffix class="icon ion-ios-close" (click)="poistaValittuToimittaja()"></i>
              }
              @if ((toimittajaVar?.ngControl?.dirty || toimittajaVar?.ngControl?.touched) && toimittajaVar.ngControl?.errors?.required) {
                <mat-error>{{ 'maksut.muokkaa.validation.toimittaja.required' | translate | async }}</mat-error>
              }
              <mat-hint>
                @if (naytaToimittajaCheck()) {
                  <mat-icon style="font-size: calc(100% + 4px); position: absolute; top: 4px; left: -4px" class="green-text">done</mat-icon>
                }
                @if (naytaToimittajaCheck()) {
                  <span style="display: inline-block; width: 14px"></span>
                }
                @if (toimittajahaunVihjetekstiObservable | async; as toimittajahaunVihjeteksti) {
                  <span [class.red-warning]="toimittajahaunVihjeteksti === ('maksut.muokkaa-toimittajaa' | translate | async)">{{ toimittajahaunVihjeteksti }}</span>
                }
              </mat-hint>
            </mat-form-field>
            <mat-autocomplete #toimittajaAuto="matAutocomplete" [displayWith]="toimittajaDisplayFn">
              @for (toimittaja of suodatetutToimittajat | async; track toimittaja) {
                <mat-option [value]="toimittaja"> {{ toimittaja.numero }} {{ toimittaja.nimi }} {{ toimittaja.ytunnus ? `(${naytettavaTunniste(toimittaja.ytunnus)})` : '' }} </mat-option>
              }
            </mat-autocomplete>
            <mat-form-field>
              <mat-label>{{ 'maksut.muokkaa.saaja' | translate | async }}</mat-label>
              <input matInput class="alignLeft" #saajaVar="matInput" [formField]="rivi.saaja" autocomplete="kirjnpitomekiarki" data-lpignore="true" />
              @if ((saajaVar?.ngControl?.dirty || saajaVar?.ngControl?.touched) && saajaVar.ngControl?.errors?.required) {
                <mat-error>{{ 'maksut.muokkaa.validation.saaja.required' | translate | async }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'maksut.muokkaa.ytunnus' | translate | async }}</mat-label>
              <input matInput class="alignLeft" #ytunnusVar="matInput" [formField]="rivi.ytunnus" autocomplete="kirjnpitomekiarki" data-lpignore="true" />
              @if ((ytunnusVar?.ngControl?.dirty || ytunnusVar?.ngControl?.touched) && ytunnusVar.ngControl?.errors?.required) {
                <mat-error>{{ 'maksut.muokkaa.validation.ytunnus.required' | translate | async }}</mat-error>
              }
            </mat-form-field>
            @if (muutTunnisteet().length) {
              <div class="gray-text muut-tunnisteet">{{ 'maksut.toimittajat.muut-tunnisteet' | translate: { tunnisteet: muutTunnisteet().join(', ') } | async }}</div>
            }
            <mat-form-field>
              <mat-label>{{ 'maksut.muokkaa.iban' | translate | async }}</mat-label>
              <input matInput class="alignLeft" #ibanVar="matInput" [formField]="rivi.iban" autocomplete="kirjnpitomekiarki" data-lpignore="true" />
              @if ((ibanVar?.ngControl?.dirty || ibanVar?.ngControl?.touched) && ibanVar.ngControl?.errors?.required) {
                <mat-error>{{ 'maksut.muokkaa.validation.iban.required' | translate | async }}</mat-error>
              }
              @if ((ibanVar?.ngControl?.dirty || ibanVar?.ngControl?.touched) && ibanVar.ngControl?.errors?.invalidiban) {
                <mat-error>{{ 'maksut.muokkaa.validation.iban.invalid' | translate | async }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'maksut.muokkaa.bic' | translate | async }}</mat-label>
              <input matInput class="alignLeft" #bicVar="matInput" [formField]="rivi.bic" autocomplete="kirjnpitomekiarki" data-lpignore="true" />
              @if ((bicVar?.ngControl?.dirty || bicVar?.ngControl?.touched) && bicVar.ngControl?.errors?.required) {
                <mat-error>{{ 'maksut.muokkaa.validation.bic.required' | translate | async }}</mat-error>
              }
              @if ((bicVar?.ngControl?.dirty || bicVar?.ngControl?.touched) && bicVar.ngControl?.errors?.invalidbic) {
                <mat-error>{{ 'maksut.muokkaa.validation.bic.invalid' | translate | async }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'maksut.muokkaa.pvm' | translate | async }}</mat-label>
              <input numberDatePicker matInput #pvmVar="matInput" [formField]="rivi.pvm" [matDatepicker]="dayPicker" [min]="minDate" [max]="maxDate" autocomplete="kirjnpitomekiarki" data-lpignore="true" />
              @if ((pvmVar?.ngControl?.dirty || pvmVar?.ngControl?.touched) && pvmVar.ngControl?.errors?.required) {
                <mat-error>{{ 'maksut.muokkaa.validation.pvm.required' | translate | async }}</mat-error>
              }
              @if ((pvmVar?.ngControl?.dirty || pvmVar?.ngControl?.touched) && pvmVar.ngControl?.errors?.matDatepickerParse) {
                <mat-error>{{ 'maksut.muokkaa.validation.pvm.matDatepickerParse' | translate | async }}</mat-error>
              }
              @if ((pvmVar?.ngControl?.dirty || pvmVar?.ngControl?.touched) && pvmVar.ngControl?.errors?.matDatepickerMax) {
                <mat-error>{{ 'maksut.muokkaa.validation.pvm.matDatepickerMax' | translate | async }}</mat-error>
              }
              @if ((pvmVar?.ngControl?.dirty || pvmVar?.ngControl?.touched) && pvmVar.ngControl?.errors?.matDatepickerMin) {
                <mat-error>{{ 'maksut.muokkaa.validation.pvm.matDatepickerMin' | translate | async }}</mat-error>
              }
              <mat-datepicker-toggle matSuffix [for]="dayPicker"></mat-datepicker-toggle>
              <mat-datepicker #dayPicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'maksut.muokkaa.erapvm' | translate | async }}</mat-label>
              <input numberDatePicker matInput #erapvmVar="matInput" [formField]="rivi.erapvm" [matDatepicker]="dueDatePicker" [min]="minDate" [max]="maxDate" autocomplete="kirjnpitomekiarki" data-lpignore="true" />
              @if ((erapvmVar?.ngControl?.dirty || erapvmVar?.ngControl?.touched) && erapvmVar.ngControl?.errors?.required) {
                <mat-error>{{ 'maksut.muokkaa.validation.erapvm.required' | translate | async }}</mat-error>
              }
              @if ((erapvmVar?.ngControl?.dirty || erapvmVar?.ngControl?.touched) && erapvmVar.ngControl?.errors?.matDatepickerParse) {
                <mat-error>{{ 'maksut.muokkaa.validation.erapvm.matDatepickerParse' | translate | async }}</mat-error>
              }
              @if ((erapvmVar?.ngControl?.dirty || erapvmVar?.ngControl?.touched) && erapvmVar.ngControl?.errors?.matDatepickerMax) {
                <mat-error>{{ 'maksut.muokkaa.validation.erapvm.matDatepickerMax' | translate | async }}</mat-error>
              }
              @if ((erapvmVar?.ngControl?.dirty || erapvmVar?.ngControl?.touched) && erapvmVar.ngControl?.errors?.matDatepickerMin) {
                <mat-error>{{ 'maksut.muokkaa.validation.erapvm.matDatepickerMin' | translate | async }}</mat-error>
              }
              <mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #dueDatePicker></mat-datepicker>
            </mat-form-field>
            <br />
            <mat-form-field>
              <mat-label>{{ 'maksut.muokkaa.summa' | translate | async }}</mat-label>
              <input decimalNumberField matInput #summaVar="matInput" class="alignLeft" [formField]="rivi.summa" autocomplete="kirjnpitomekiarki" data-lpignore="true" />
              @if ((summaVar?.ngControl?.dirty || summaVar?.ngControl?.touched) && summaVar.ngControl?.errors?.required) {
                <mat-error>{{ 'maksut.muokkaa.validation.summa.required' | translate | async }}</mat-error>
              }
              @if ((summaVar?.ngControl?.dirty || summaVar?.ngControl?.touched) && summaVar.ngControl?.errors?.min) {
                <mat-error>{{ 'maksut.muokkaa.validation.summa.min' | translate | async }}</mat-error>
              }
              @if ((summaVar?.ngControl?.dirty || summaVar?.ngControl?.touched) && summaVar.ngControl?.errors?.max) {
                <mat-error>{{ 'maksut.muokkaa.validation.summa.max' | translate | async }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'maksut.muokkaa.viite' | translate | async }}</mat-label>
              <input matInput class="alignLeft" #viiteVar="matInput" [formField]="rivi.viite" autocomplete="kirjnpitomekiarki" data-lpignore="true" />
              @if ((viiteVar?.ngControl?.dirty || viiteVar?.ngControl?.touched) && viiteVar.ngControl?.errors?.viitenumero) {
                <mat-error>{{ 'maksut.muokkaa.validation.viite.viitenumero' | translate | async }}</mat-error>
              }
              @if ((viiteVar?.ngControl?.dirty || viiteVar?.ngControl?.touched) && viiteVar.ngControl?.errors?.viestitaiviite) {
                <mat-error>{{ 'maksut.muokkaa.validation.viite.viite-tai-viesti' | translate | async }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'maksut.muokkaa.viesti' | translate | async }}</mat-label>
              <textarea matInput [formField]="rivi.viesti" cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="35" autocomplete="kirjnpitomekiarki"></textarea>
              @if ((viiteVar?.ngControl?.dirty || viiteVar?.ngControl?.touched) && viiteVar.ngControl?.errors?.viestitaiviite) {
                <mat-error>{{ 'maksut.muokkaa.validation.viesti.viite-tai-viesti' | translate | async }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'maksut.muokkaa.lisatiedot' | translate | async }}</mat-label>
              <textarea matInput [formField]="rivi.lisatiedot" cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="35" autocomplete="kirjnpitomekiarki"></textarea>
            </mat-form-field>
            @if (naytaProjektitObservable | async) {
              <mat-form-field>
                <mat-label>{{ 'maksut.muokkaa.projekti' | translate | async }}</mat-label>
                <mat-select [formField]="rivi.projektiAvain">
                  <mat-option [value]="''">{{ 'maksut.muokkaa.ei-projektia' | translate | async }}</mat-option>
                  @for (projekti of naytettavatProjektitObservable | async; track projekti.avain) {
                    <mat-option [value]="projekti.avain">{{ projekti.nimi }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (onkoSuoriteTaiLaskuperusteinenObservable | async) {
              <mat-form-field>
                <mat-label>{{ 'maksut.muokkaa.toimituspaivamaara' | translate | async }}</mat-label>
                <input matInput class="alignLeft" #toimituspvmVar="matInput" [formField]="rivi.toimituspvm" [matDatepicker]="deliveryDatePicker" autocomplete="kirjnpitomekiarki" data-lpignore="true" />
                @if ((toimituspvmVar?.ngControl?.dirty || toimituspvmVar?.ngControl?.touched) && toimituspvmVar.ngControl?.errors?.matDatepickerParse) {
                  <mat-error>{{ 'maksut.muokkaa.validation.toimituspvm.matDatepickerParse' | translate | async }}</mat-error>
                }
                @if ((toimituspvmVar?.ngControl?.dirty || toimituspvmVar?.ngControl?.touched) && toimituspvmVar.ngControl?.errors?.matDatepickerMax) {
                  <mat-error>{{ 'maksut.muokkaa.validation.toimituspvm.matDatepickerMax' | translate | async }}</mat-error>
                }
                @if ((toimituspvmVar?.ngControl?.dirty || toimituspvmVar?.ngControl?.touched) && toimituspvmVar.ngControl?.errors?.matDatepickerMin) {
                  <mat-error>{{ 'maksut.muokkaa.validation.toimituspvm.matDatepickerMin' | translate | async }}</mat-error>
                }
                <mat-datepicker-toggle matSuffix [for]="deliveryDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #deliveryDatePicker></mat-datepicker>
              </mat-form-field>
            }
            <div class="button-container">
              <!-- <div *ngIf="tositeArray.controls?.length === i + 1"> -->
              @if (virheviestiLatausOnKesken()) {
                <div class="error-text" style="padding-bottom: 2em">
                  {{ virheviestiLatausOnKesken() }}
                </div>
              }
              @if (virheviestiPysyva()) {
                <div class="error-text" style="padding-bottom: 2em">
                  {{ virheviestiPysyva() }}
                </div>
              }
              @if (virheviestiTallennus()) {
                <div class="error-text" style="padding-bottom: 2em">
                  {{ virheviestiTallennus() }}
                </div>
              }
              @if ((latausvirheetObservable | async)?.length > 0) {
                <div class="error-text" style="padding-bottom: 2em; text-align: left">
                  {{ 'lasku.tiedoston-lahettaminen-epaonnistui-alku' | translate | async }}
                  <ul>
                    @for (virhe of latausvirheetObservable | async; track virhe) {
                      <li>{{ virhe }}</li>
                    }
                  </ul>
                  {{ 'lasku.tiedoston-lahettaminen-epaonnistui-loppu' | translate | async }}
                </div>
              }
              <button class="primarybutton" mat-button (click)="save()">{{ 'yleiset.tallenna' | translate | async }}</button>
              <br />
              @if (1 > (latausvirheetObservable | async)?.length && 100 > (donePercentageObservable | async) && uploadTasks.length > 0) {
                <div style="width: 50%; margin-top: 2em; text-align: center; display: inline-block">
                  <mat-progress-bar mode="determinate" [value]="donePercentageObservable | async"></mat-progress-bar>
                  <div style="padding-top: 3px; font-size: 12px">{{ 'kuitit.muokkaa.ladataan' | translate | async }}</div>
                </div>
              }
              <!-- </div> -->
            </div>
          </div>
          <div class="tosite-sivut">
            @if (kuvat[i]?.length > 1) {
              <div class="image-change-page-buttons-container">
                @for (kuva of kuvat[i]; track kuva; let a = $index) {
                  <div class="image-change-page-button lemon-mat-elevation-z4" [class.selected-image]="kuva == nakyvatKuvat[i]" (click)="vaihdaNakyvaKuva(0, kuva)">
                    {{ a + 1 }}
                  </div>
                }
              </div>
            }
            <div app-tosite-kuva [url]="nakyvatKuvat[i]" class="mat-elevation-z4" style="width: 1080px; max-width: 100%; margin-bottom: 50px; position: relative; min-height: 50px"></div>
          </div>
        </div>
      }
    </div>
  </form>
</div>
